import { Button } from 'features/components/Button';
import { ROUTE_MAP } from 'features/entry-form-v2/utils/routeMap';
import { useLanguage } from 'features/hooks/useLanguage';
import { useProjectId } from 'features/hooks/useProjectId';
import { useEntries } from 'hooks/store';
import { useNavigate } from 'react-router-dom';
import { LanguageType } from 'types';

export const ImportCompleted = ({
	importedCount,
	skippedCount
}: {
	importedCount: number;
	skippedCount: number;
}) => {
	const language = useLanguage();
	const translation = DICTIONARY[language];

	const [_, fetchEntries] = useEntries({ lazy: true, filtered: true });

	const projectId = useProjectId();

	const navigate = useNavigate();

	const onBackToDatasetClicked = () => {
		fetchEntries();

		navigate(ROUTE_MAP.projects.byId.dataset.createPath({ projectId }));
	};

	return (
		<div>
			<h2 className="text-2xl font-bold">{translation.title}</h2>

			<p className="text-base mt-4">
				{translation.codelistImported(importedCount, skippedCount)}
			</p>

			<p className="text-base mt-4">{translation.dontRemoveVariable}</p>

			<p className="text-base mt-4">{translation.recommendMoveVariableLast}</p>

			<Button
				className="mt-10"
				onClick={onBackToDatasetClicked}
				text={translation.backToDataset}
			/>
		</div>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		title: 'Import completed',
		codelistImported: (importedCount: number, skippedCount: number) =>
			`Imported ${importedCount} records and skipped ${skippedCount} records that could not be matched to any entry.`,
		dontRemoveVariable:
			'It is important that you do not delete the variable, as this will make it difficult to import data in the future.',
		recommendMoveVariableLast:
			'It is recommended to move the ID variable to the end of the variable list.',

		backToDataset: 'Back to dataset'
	},

	[LanguageType.Norwegian]: {
		title: 'Import ferdig',
		codelistImported: (importedCount: number, skippedCount: number) =>
			`Det ble importert ${importedCount} rader og hoppet over ${skippedCount} rader som ikke kunne matches til noen oppføring.`,
		dontRemoveVariable:
			'Det er viktig at du ikke sletter ID-variabelen i datasettet ditt, da den er nødvendig for å senere kunne importere nye data i prosjektet.',
		recommendMoveVariableLast:
			'Det anbefales å flytte ID variabelen til slutten av variabel listen.',

		backToDataset: 'Tilbake til datasettet'
	}
} as const;
